import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=620b59a1&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=620b59a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b59a1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsPage: require('/var/www/k9-frontend/k9-front-20261006142511/node_modules/sitis-nuxt/lib/cms/CmsPage.vue').default})
